export const MapPrefixSeoForProduct = {
  '/catalog/tyres/leto': 'Летние шины',
};
